"use client";

import { msg } from "@lingui/core/macro";
import { Trans, useLingui } from "@lingui/react/macro";
import { ExternalLinkIcon, ListFilterPlusIcon } from "lucide-react";
import React from "react";
import { InteractiveCell, InteractiveCellAction } from "./interactive-cell";

type QueryCellProps = {
  query: string | null | undefined;
  onAddFilter?: (query: string) => void;
  onOpenGoogleSearch?: boolean;
};

export const QueryCell = ({
  query,
  onAddFilter,
  onOpenGoogleSearch = false,
}: QueryCellProps) => {
  const { t } = useLingui();

  const handleOpenGoogleSearch = React.useCallback(() => {
    if (!query) return;
    const url = `https://www.google.com/search?q=${encodeURIComponent(query)}`;
    window.open(url, "_blank", "noopener,noreferrer");
  }, [query]);

  if (!query) {
    return <span className="text-muted-foreground">-</span>;
  }

  if (query === "N/A") {
    return <span className="text-muted-foreground">{query}</span>;
  }

  const actions: InteractiveCellAction[] = [];

  // 「別タブで開く」を先に追加（一番左に表示）
  if (onOpenGoogleSearch) {
    actions.push({
      icon: ExternalLinkIcon,
      onClick: handleOpenGoogleSearch,
      label: <Trans>Open Google search in new tab</Trans>,
      ariaLabel: t(msg`Search on Google`),
    });
  }

  if (onAddFilter) {
    actions.push({
      icon: ListFilterPlusIcon,
      onClick: () => onAddFilter(query),
      label: <Trans>Add to filter</Trans>,
      ariaLabel: t(msg`Add to filter`),
    });
  }

  return (
    <InteractiveCell text={query} actions={actions} enableTruncate={true} />
  );
};
